.assetLogoContainer {
  --ixf-asset-logo-size: 32px; // Default size
  --ixf-asset-logo-border-radius: 6px;

  &.size {
    &-x-small {
      --ixf-asset-logo-size: 16px;
      --ixf-asset-logo-border-radius: var(--ixf-border-radius-1);
    }

    &-small {
      --ixf-asset-logo-size: 24px;
    }
  }

  &.assetLogo,
  &.placeholder {
    flex: 0 0 auto;
    height: var(--ixf-asset-logo-size);
    width: var(--ixf-asset-logo-size);
    border-radius: var(--ixf-asset-logo-border-radius);
  }

  &.assetLogo {
    display: block;
    object-fit: contain;
    border: 1px solid var(--ixf-color-separator);
    background: var(--ixf-color-background);
  }

  &.placeholder {
    display: flex;
    justify-content: center;
    align-items: center;

    &.withBorder {
      border: 1px dashed var(--ixf-text-tone-md);
    }
  }
}
